import * as React from 'react'

import { cn } from '@/lib/utils'

interface ChatPopupContainerProps {
  children: React.ReactNode
  onClose: () => void
  isMaximized?: boolean
  /** When true, chat fills the viewport (mobile). When false on desktop, reserves space below the site header. */
  isMobileFullscreen?: boolean
}

export const ChatPopupContainer: React.FC<ChatPopupContainerProps> = ({
  children,
  onClose,
  isMaximized = false,
  isMobileFullscreen = false,
}) => {
  if (isMaximized) {
    if (isMobileFullscreen) {
      return (
        <div className="fixed inset-0 z-[9999] flex items-start justify-center p-2 sm:p-4">
          <div className="absolute inset-0 bg-black/50" onClick={onClose} />
          <div className="relative flex h-[90vh] w-full max-w-full flex-col overflow-hidden rounded-lg bg-white shadow-xl sm:max-w-6xl">
            {children}
          </div>
        </div>
      )
    }

    return (
      <div className="fixed inset-0 z-[9999]">
        <div className="absolute inset-0 bg-black/50" onClick={onClose} />
        <div className="fixed inset-x-0 bottom-0 top-16 flex justify-center p-2 sm:p-4 md:top-20 pointer-events-none">
          <div className="pointer-events-auto relative flex h-full w-full max-w-full flex-col overflow-hidden rounded-lg bg-white shadow-xl sm:max-w-6xl lg:max-w-7xl">
            {children}
          </div>
        </div>
      </div>
    )
  }

  return (
    <div
      className={cn(
        'fixed bottom-0 right-4 z-[9999]',
        'w-[380px] h-[500px]',
        'bg-white rounded-t-lg shadow-2xl',
        'flex flex-col overflow-hidden',
        'border border-gray-200'
      )}
    >
      {children}
    </div>
  )
}
